<template>
  <div class="errors">
    <div>
      <v-alert
        :color="err.type === 'E' ? 'red' : 'green'"
        :type="err.type === 'E' ? 'error' : 'success'"
        v-for="(err, i) in getFeeds"
        :key="i"
      >
        {{ err.alert }}
      </v-alert>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getFeeds"]),
  },
};
</script>

<style>
.errors {
  margin: 10px;
  left: 50%;
  transform: translateX(-50%);
  position: fixed;
  z-index: 5;
  top: 0;
  width: fit-content;
  max-width: 600px;
}
</style>